module.exports = __webpack_public_path__ + "img/lg_ring_g_l_0_0@3x.d92e0c2a.png";